import { OrderSummary as TransportOrder } from '../transportation/models/shared/order-summary';
import { AppUtils } from './app-utils';

/**
 * A collection of utility methods used throughout the app
 */
export abstract class OrderUtils {

    public static PlanningGroupCompare = (a : TransportOrder, b : TransportOrder) => {
        return AppUtils.simpleCompare(a.jobName, b.jobName) || AppUtils.simpleCompare(a.id, b.id);
    }

}
